module.exports = __webpack_public_path__ + "2195cd0ee03aefa4ec119c29298f06a2.jpg";